import { FiBell } from "react-icons/fi";
import { FcBusinessman } from "react-icons/fc";
import { AiOutlineMail } from "react-icons/ai";
import { RiArrowDropDownLine } from "react-icons/ri";
import { AiOutlineMenu } from "react-icons/ai";
import { connect, useDispatch, useSelector } from "react-redux";
import { FcBusinesswoman } from "react-icons/fc";
import { FcBearish } from "react-icons/fc";
import UserAvatar from "react-user-avatar";
import React, { useRef, useEffect, useState } from "react";
import "../Assets/Css/Navbar.scss";
import { sidebarOpen } from '../Services/Sidebar/action'
import { Link, useNavigate } from "react-router-dom";

const Navbar = (props) => {

  const isOpen = useSelector(state => state.sidebarReducer.isOpen);
  const dispatch = useDispatch();
  function menuIconClick() {
    dispatch(sidebarOpen());
  }
  const [show, setShow] = useState(false);
  const [sshow, setSshow] = useState(false);

  useEffect(() => {
    setShow(false);
    setSshow(false);
  }, []);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShow(false);
        }
      }
      function handleClickOutside2(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSshow(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("mousedown", handleClickOutside2);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("mousedown", handleClickOutside2);

      };
    }, [ref]);
  }
  const data = JSON.parse(localStorage.getItem('user'));
  const shId = data.id;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.removeItem('user')
    navigate('/login')
  }

  return (
    <>
      <div className="parent">
        <div className="left-part">
          <div className={`${isOpen ? "outside-closed" : "outside"}`} >
            <AiOutlineMenu onClick={menuIconClick} />
          </div>
        </div>
        <div className="right-part">
          <div className="bell-icon notification-part">
            <button onClick={() => setShow(true)} className="bt">
              <FiBell className="bel" />
            </button>
            {show ? (
              <div ref={wrapperRef}>
                <div className="notification-hover-block">
                  <div className="notifiction-custom-part">
                    <div className="hover-block">
                      <div className="squre">
                        <div className="popup-heding">
                          Notifictions
                          <div className="notifiction-count">5 new</div>
                        </div>
                        <div className="notification-scroll">
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinesswoman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinessman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!{" "}
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBearish />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="user">
                            <div className="h5-css">
                              <div className="user-icon">
                                <FcBusinesswoman />
                              </div>
                              <div className="h5-mrgin">
                                <h5 className="user-notifi">
                                  Roman Joined the Team!
                                </h5>
                                <h6 className="user-notifi-second">
                                  Notifiction pnel currentl dddqwqwe{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                          </div>

                        <div className="bell-popup-btn">
                          <button className="btn-width">
                            See All Notifiction
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="line"></div>
          <button onClick={() => setSshow(true)} className="bbt cor">

            <div className="profile">
              {/* <button className="bt-1">A</button> */}
              <UserAvatar size="30" name={(props.user && props.user.name) || 'CD'} color="#5757fe" />
            </div>
            <div className="email">
              <div className="name">
                {" "}
                {props.user && props.user.name} <RiArrowDropDownLine className="cor" />
              </div>
            </div>
          </button>

          {sshow ? (
            <div ref={wrapperRef}>


              <div className="prodiv">
                <ul className="unordered-list">
                  <div className="user-profile">
                    <h4 className="card-heading">User Profile</h4>
                  </div>
                  {/* ---------account div-------- */}
                  <div className="dsp">
                    <div className="avatar">
                      <UserAvatar size="80" name={(props.user && props.user.name) || 'cd'} color="#5757fe" />
                    </div>
                    <div className="alll">
                      <div>
                        <h4 className="jlr">{props.user && props.user.name}</h4>
                        <h6 className="adm">{props.user && props.user.role.name}</h6>
                      </div>
                      <div className="dsp-1">
                        <p>
                          <AiOutlineMail />
                        </p>
                        <div className="fly">
                          <a href="mailto:maheshsuthar083@gmail.com">{props.user && props.user.email}</a>
                        </div>
                        <div>
                        </div>
                      </div>
                      <div>
                        <Link to="/shareholder/edit" state={{ data : { shId } }} style={{ textDecoration : "none" }}>
                          <p>Edit User</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* ----items-list-div----- */}
                  <div className="buttonn-hover">
                    <button onClick={handleLogout} className="bty">Logout</button>
                  </div>
                </ul>

              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authenticationReducer.user
  }
}

export default connect(mapStateToProps)(Navbar);
